// GTM-only implementation - all analytics handled through Google Tag Manager

export const gtmPageview = (url: string) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'page_view',
      page_location: window.location.href,
      page_path: url,
      page_title: document.title
    })
  }
}

export const gtmEvent = ({
  event,
  category,
  action,
  label,
  value,
  customParameters = {}
}: {
  event: string
  category?: string
  action?: string
  label?: string
  value?: number
  customParameters?: Record<string, any>
}) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event,
      event_category: category,
      event_action: action,
      event_label: label,
      event_value: value,
      ...customParameters
    })
  }
}
